import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { CustomCmsVideoComponent } from '../../models/cms-links.model';
@Component({
    selector: 'app-shared-image',
    templateUrl: './shared-image.component.html',
    styleUrl: './shared-image.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedImageComponent implements OnInit {
  public componentData: CustomCmsVideoComponent;

  constructor(public component: CmsComponentData<CustomCmsVideoComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
